import { IEditable, IWithName, ServerEntityType, PhaseCategory } from "../../entities/common";
import { IProcessStage, ProjectState } from "../../entities/Subentities";

export type StagePhase = {
    id: string;
    category: PhaseCategory;
    name: string;
    color: string;
    order: number;
    projectState?: ProjectState;
};

export type StagePhaseUpdate = Partial<StagePhase> & { id: string };

export interface StagePhaseInfo {
    id: string;
    category: PhaseCategory;
    name: string;
    color: string;
    order: number;
}

export interface Process extends IEditable {
    id: string;
    attributes: IProcessAttrs;
    isDefault: boolean;
    areStagesEditable: boolean;
    isSystem: boolean;
    stagePhases: StagePhase[];
    stages: IProcessStage[];
    entitiesCount: number;
    isLegacy: boolean;
}

export type IProcessAttrs = IWithName & {
    Description: string;
    Status: ProcessStatus;
    EntityType: ServerEntityType;
    CreatedDate: string;
};

export enum ProcessStatus {
    Draft = 0,
    Active = 1,
    Inactive = 2,
}

export const canBeDeleted = (process: Process) => process.isEditable && process.areStagesEditable && !process.isDefault && !process.entitiesCount;

const projectStateByPhaseCategoryMap: Record<PhaseCategory, ProjectState> = {
    [PhaseCategory.Initiating]: ProjectState.NotStarted,
    [PhaseCategory.Planning]: ProjectState.InProgress,
    [PhaseCategory.Executing]: ProjectState.InProgress,
    [PhaseCategory.MonitoringAndControlling]: ProjectState.InProgress,
    [PhaseCategory.Closing]: ProjectState.InProgress,
    [PhaseCategory.Custom]: ProjectState.InProgress,
    [PhaseCategory.Suspended]: ProjectState.Suspended,
    [PhaseCategory.Canceled]: ProjectState.Canceled
};

export const getPhaseDefaultProjectState = (phase: StagePhase) =>
    phase.projectState ?? projectStateByPhaseCategoryMap[phase.category];
